// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/always-grey.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.home-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    background-color: #151515;
    color: #FFF;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Header Section */
.home-container .home-header {
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    width: 100%;
    justify-content: center;
}

.home-container .home-header-title {
    font-size: 40px
    /* text-align: center; */
}

.home-container .home-header-description {
    font-size: 20px;
    /* text-align: center; */
    max-width: 80%;
}

.home-container .home-header-button {
    height: 50px;
    color: #151515;
    font-size: 18px;
    background: #f7941d;
    border: none;
    margin-bottom: 30px;
}
.home-container .home-header-button:hover {
    height: 50px;
    color: #151515 !important;
    font-size: 18px;
    background: #f7941d !important;
    border: none;
}

/* Quotes Section */
.home-container .quotes-section {
    margin-top: 80px;
    background: #151515;
}

.home-container .quotes-section-title {
    font-size: 40px;
    font-weight: 500;
}

.home-container .quotes-container {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 20px;
    margin-top: 25px;
    background: #262626;
    align-items: center;
}

.home-container .quotes-left-content {
    max-width: 45%;
    text-align: left;
}

.home-container .quotes-left-content .subtitle {
    font-size: 30px;
    font-weight: 500;
}


.home-container .quotes-left-content .text {
    font-size: 16px;
    font-weight: 300;
    margin-top: 10px;
    line-height: 1.5;
}

.home-container .quotes-left-content .btn-why-thy {
    height: 25px;
    color: #151515;
    font-size: 18px;
    background: #f7941d;
    border: none;
    font-weight: 600;
}
.home-container .quotes-left-content .btn-why-thy:hover {
    height: 30px;
    color: #151515 !important;
    font-size: 22px;
    background: #f7941d !important;
    border: none;
    font-weight: 600;
}

.home-container .work-section {
    margin-top: 0;
    padding-top: 80px;
    background: #151515;
  }
  
  .home-container .work-header {
    font-size: 40px;
    font-weight: 500;
  }
  
  .home-container .work-body {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 25px;
    height: 481px;
    background: #262626;
    align-items: center;
    height: auto;
    padding: 20px;
  }
  
  .home-container  .work-banner {
    /* Add any styles for the Banner1 component if needed */
  }
  
  .home-container  .work-content {
    max-width: 45%;
    text-align: left;
  }
  
  .home-container  .work-title {
    font-size: 30px;
    font-weight: 500;
  }
  
  .home-container .highlight-text {
    color: #f7941d;
  }
  
  .home-container  .work-description {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.5;
    margin-top: 10px;
  }
  
  .home-container  .work-button {
    margin-top: 20px;
  }
  
  .home-container .why-thy-button {
    height: 25px;
    color: #151515;
    font-size: 18px;
    background: #f7941d;
    border: none;
    font-weight: 600;
    margin-top: 20px;
  }
  .home-container .why-thy-button:hover {
    height: 30px;
    color: #151515 !important;
    font-size: 22px;
    background: #f7941d !important;
    border: none;
    font-weight: 600;
    margin-top: 20px;
  }
/* Image Section */
.home-container .image-section {
    /* background: #151515; */
    width: 80%;
    gap: 30px;
    margin-top: 80px;
    display: flex;
    flex-direction: column;
}

.home-container .image-section-title {
    font-size: 40px;
    /* margin-bottom: 25px; */
    font-weight: 500;
}

.home-container .image-section-div {
    display: flex;
    gap: 20px;
}

.home-container .image-section .highlight {
    color: #f7941d;
}
:where(.css-dev-only-do-not-override-1kf000u).ant-modal .ant-modal-header{
    background-color: unset !important;
}
.home-container .image-section .image-item {
    /* height: 214px; */
    padding: 20px;
    border: 1px solid #d9d9d91f;
    background: #262626;
    display: flex;
    text-align: left;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-radius: 4px;
    line-height: 1.5;
}

.home-container .image-section .image-item.large {
    width: 50%;
}

.home-container .image-section .image-item.small {
    width: 25%;
}

/* Carousel Section */
.home-container .carousel-section {
    margin-top: 80px;
    background: #151515;
    width: 70%;
    padding: 30px 0;
    
}

.home-container .carousel-section-title {
    font-size: 40px;
    color: #FFF;
    margin-bottom: 25px;
    font-weight: 500;
}

.home-container .contact-title{
    font-size: 40px;
    color: #FFF;
    margin-top: 80px;
    font-weight: 500;
}
.home-container .carousel-section .carousel-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    background: red;
}

.home-container .carousel-item .profile-image {
    background-color: #262626;
    padding: 20px;
    color: #FFF;
    display: flex;
    justify-content: center;
}
.home-container .carousel-item .profile-image-container {
    font-size: 18px;
    width: 170px;
    height: 165px;
    border-radius: 100px;
    background: #fff;
    overflow: hidden;
  }
.home-container .profile-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 100px;
}

.home-container .carousel-item .name,
.home-container .carousel-item .review {
    background-color: #262626;
    padding: 20px;
    color: #FFF;
}
.ant-carousel .slick-list{
    display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
}
:where(.css-dev-only-do-not-override-1kf000u).ant-carousel .slick-list .slick-slide >div>div {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* width: 80% !important; */
}
/* Modal Styles */
.modal-container {
    border: 2px solid #f7941d;
    height: 460px;
    border-radius: 8px;
}

.modal-body {
    font-size: 16px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    font-weight: 600;
}

.modal-footer .btn-cancel {
    border-radius: 12px;
}

.modal-footer .btn-post {
    background: #f7941d;
    color: #151515;
    border-radius: 12px;
}

.upload-container {
    margin-top: 16px;
    display: flex;
    align-items: center;
}

.upload-preview {
    margin-left: 10px;
}

.upload-preview img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
}


@media only screen and (max-width: 1000px) {
    .home-container .home-header {
        margin-top: 50px ;
        /* width: 80%; */
    }
    .home-container .home-header-title {
        font-size: 28px;
    }
    
.home-container .home-header-button {
    height: 40px;
    color: #151515;
    font-size: 20px;
    background: #f7941d;
    border: none;
}
.home-container .quotes-section {
    margin-top: 40px;
  display: flex;
  flex-direction: column;
  width: 80%;
  align-items: center;
}
.home-container .quotes-section-title {
    font-size: 28px;
}
.home-container .quotes-container {
    flex-direction: column;
    gap: 30px;
    height: auto;
    width: 100%
}

.home-container .quotes-left-content {
    max-width:fit-content;
    text-align: left;
}

.home-container .quotes-left-content .subtitle {
    font-size: 24px;
}
.home-container .work-section {
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    height: auto;
    width: 100%
  }
.home-container .work-header {
    font-size: 28px;
  }
  
  .home-container .work-body {
   flex-direction: column;
   height: auto;
   width: 80%;
  }
  
  .home-container  .work-banner {
    /* Add any styles for the Banner1 component if needed */
  }
  
  .home-container  .work-content {
    max-width:fit-content;
    text-align: left;
  }
  
  .home-container  .work-title {
    font-size: 24px;
  }
  
  .home-container .highlight-text {
    color: #f7941d;
  }
  
  .home-container  .work-description {
    font-size: 16px;
    margin-top: 10px;
  }
  
  .home-container  .work-button {
    margin-top: 20px;
  }
  
  .home-container .why-thy-button {
    height: 30px;
    color: #151515;
    font-size: 22px;
    background: #f7941d;
    border: none;
    font-weight: 600;
    margin-top: 20px;
  }

  .home-container .image-section-title {
    font-size: 28px;
}
.home-container .image-section-div {
    flex-direction: column;
    width: 80%;
}

.home-container .image-section .highlight {
    color: #f7941d;
}
.home-container .contact-title{
    font-size: 40px;
}
.home-container .carousel-section-title {
    font-size: 40px;
}
}
.ant-spin .ant-spin-dot-holder{
    color: #f7941d;
}
/* === Carousel Dots Customization === */
.ant-carousel .slick-dots {
  bottom: 0; /* Adjust vertical positioning if needed */
}

.ant-carousel .slick-dots li {
  margin: 0 6px;
}

.ant-carousel .slick-dots li button {
  background-color: #888888; /* Inactive dot color */
  width: 10px;
  height: 10px;
  border-radius: 50%;
  opacity: 1; /* Ensures visible */
  transition: background-color 0.3s ease;
}

.ant-carousel .slick-dots li.slick-active button {
  background-color: #f7941d !important; /* Active dot color */
}
.home-container .contact-form:hover{
    transform: scale(1.01);
    box-shadow: 0 0 15px #d9d9d91f;
}
.home-container .contact-form{
    box-shadow: 0 0 15px #bebdbd1f;
    margin-top: 25px;
}

.home-container .image-section .image-item {
    box-shadow: 0 0 15px #bebdbd1f;
}

.home-container .image-section .image-item:hover {
    transform: scale(1.01);
    box-shadow: 0 0 15px #d9d9d91f;
}
.underline-path {
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
  animation: drawLine 2s linear infinite;
}

@keyframes drawLine {
  0% {
    stroke-dashoffset: 300;
  }
  50% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -300;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,yDAA4D;AAChE;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,8BAA8B;IAC9B,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uDAAuD;EACzD;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF,kBAAkB;AAClB;IACI,yBAAyB;IACzB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb,WAAW;AACf;AACA;IACI,aAAa;QACT,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;AAC3B;AACA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;AAC/B;AACA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;;AAEJ;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,gBAAgB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,mBAAmB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ;EACF;AACF;IACI,eAAe;EACjB;;EAEA;GACC,sBAAsB;GACtB,YAAY;GACZ,UAAU;EACX;;EAEA;IACE,uDAAuD;EACzD;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;AACA;IACI,cAAc;AAClB;AACA,wCAAwC;AACxC;EACE,SAAS,EAAE,0CAA0C;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU,EAAE,oBAAoB;EAChC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;AAC7D;AACA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* General Styles */\n.home-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    background-color: #151515;\n    color: #FFF;\n    background-image: url(\"../../assets/images/always-grey.png\");\n}\n\n/* Header Section */\n.home-container .home-header {\n    margin-top: 100px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n    width: 100%;\n    justify-content: center;\n}\n\n.home-container .home-header-title {\n    font-size: 40px\n    /* text-align: center; */\n}\n\n.home-container .home-header-description {\n    font-size: 20px;\n    /* text-align: center; */\n    max-width: 80%;\n}\n\n.home-container .home-header-button {\n    height: 50px;\n    color: #151515;\n    font-size: 18px;\n    background: #f7941d;\n    border: none;\n    margin-bottom: 30px;\n}\n.home-container .home-header-button:hover {\n    height: 50px;\n    color: #151515 !important;\n    font-size: 18px;\n    background: #f7941d !important;\n    border: none;\n}\n\n/* Quotes Section */\n.home-container .quotes-section {\n    margin-top: 80px;\n    background: #151515;\n}\n\n.home-container .quotes-section-title {\n    font-size: 40px;\n    font-weight: 500;\n}\n\n.home-container .quotes-container {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    padding: 20px;\n    margin-top: 25px;\n    background: #262626;\n    align-items: center;\n}\n\n.home-container .quotes-left-content {\n    max-width: 45%;\n    text-align: left;\n}\n\n.home-container .quotes-left-content .subtitle {\n    font-size: 30px;\n    font-weight: 500;\n}\n\n\n.home-container .quotes-left-content .text {\n    font-size: 16px;\n    font-weight: 300;\n    margin-top: 10px;\n    line-height: 1.5;\n}\n\n.home-container .quotes-left-content .btn-why-thy {\n    height: 25px;\n    color: #151515;\n    font-size: 18px;\n    background: #f7941d;\n    border: none;\n    font-weight: 600;\n}\n.home-container .quotes-left-content .btn-why-thy:hover {\n    height: 30px;\n    color: #151515 !important;\n    font-size: 22px;\n    background: #f7941d !important;\n    border: none;\n    font-weight: 600;\n}\n\n.home-container .work-section {\n    margin-top: 0;\n    padding-top: 80px;\n    background: #151515;\n  }\n  \n  .home-container .work-header {\n    font-size: 40px;\n    font-weight: 500;\n  }\n  \n  .home-container .work-body {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 25px;\n    height: 481px;\n    background: #262626;\n    align-items: center;\n    height: auto;\n    padding: 20px;\n  }\n  \n  .home-container  .work-banner {\n    /* Add any styles for the Banner1 component if needed */\n  }\n  \n  .home-container  .work-content {\n    max-width: 45%;\n    text-align: left;\n  }\n  \n  .home-container  .work-title {\n    font-size: 30px;\n    font-weight: 500;\n  }\n  \n  .home-container .highlight-text {\n    color: #f7941d;\n  }\n  \n  .home-container  .work-description {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 1.5;\n    margin-top: 10px;\n  }\n  \n  .home-container  .work-button {\n    margin-top: 20px;\n  }\n  \n  .home-container .why-thy-button {\n    height: 25px;\n    color: #151515;\n    font-size: 18px;\n    background: #f7941d;\n    border: none;\n    font-weight: 600;\n    margin-top: 20px;\n  }\n  .home-container .why-thy-button:hover {\n    height: 30px;\n    color: #151515 !important;\n    font-size: 22px;\n    background: #f7941d !important;\n    border: none;\n    font-weight: 600;\n    margin-top: 20px;\n  }\n/* Image Section */\n.home-container .image-section {\n    /* background: #151515; */\n    width: 80%;\n    gap: 30px;\n    margin-top: 80px;\n    display: flex;\n    flex-direction: column;\n}\n\n.home-container .image-section-title {\n    font-size: 40px;\n    /* margin-bottom: 25px; */\n    font-weight: 500;\n}\n\n.home-container .image-section-div {\n    display: flex;\n    gap: 20px;\n}\n\n.home-container .image-section .highlight {\n    color: #f7941d;\n}\n:where(.css-dev-only-do-not-override-1kf000u).ant-modal .ant-modal-header{\n    background-color: unset !important;\n}\n.home-container .image-section .image-item {\n    /* height: 214px; */\n    padding: 20px;\n    border: 1px solid #d9d9d91f;\n    background: #262626;\n    display: flex;\n    text-align: left;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    border-radius: 4px;\n    line-height: 1.5;\n}\n\n.home-container .image-section .image-item.large {\n    width: 50%;\n}\n\n.home-container .image-section .image-item.small {\n    width: 25%;\n}\n\n/* Carousel Section */\n.home-container .carousel-section {\n    margin-top: 80px;\n    background: #151515;\n    width: 70%;\n    padding: 30px 0;\n    \n}\n\n.home-container .carousel-section-title {\n    font-size: 40px;\n    color: #FFF;\n    margin-bottom: 25px;\n    font-weight: 500;\n}\n\n.home-container .contact-title{\n    font-size: 40px;\n    color: #FFF;\n    margin-top: 80px;\n    font-weight: 500;\n}\n.home-container .carousel-section .carousel-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    background: red;\n}\n\n.home-container .carousel-item .profile-image {\n    background-color: #262626;\n    padding: 20px;\n    color: #FFF;\n    display: flex;\n    justify-content: center;\n}\n.home-container .carousel-item .profile-image-container {\n    font-size: 18px;\n    width: 170px;\n    height: 165px;\n    border-radius: 100px;\n    background: #fff;\n    overflow: hidden;\n  }\n.home-container .profile-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 100px;\n}\n\n.home-container .carousel-item .name,\n.home-container .carousel-item .review {\n    background-color: #262626;\n    padding: 20px;\n    color: #FFF;\n}\n.ant-carousel .slick-list{\n    display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n}\n:where(.css-dev-only-do-not-override-1kf000u).ant-carousel .slick-list .slick-slide >div>div {\n    display: flex !important;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    /* width: 80% !important; */\n}\n/* Modal Styles */\n.modal-container {\n    border: 2px solid #f7941d;\n    height: 460px;\n    border-radius: 8px;\n}\n\n.modal-body {\n    font-size: 16px;\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    font-weight: 600;\n}\n\n.modal-footer .btn-cancel {\n    border-radius: 12px;\n}\n\n.modal-footer .btn-post {\n    background: #f7941d;\n    color: #151515;\n    border-radius: 12px;\n}\n\n.upload-container {\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n}\n\n.upload-preview {\n    margin-left: 10px;\n}\n\n.upload-preview img {\n    width: 100px;\n    height: 100px;\n    object-fit: cover;\n    border-radius: 8px;\n}\n\n\n@media only screen and (max-width: 1000px) {\n    .home-container .home-header {\n        margin-top: 50px ;\n        /* width: 80%; */\n    }\n    .home-container .home-header-title {\n        font-size: 28px;\n    }\n    \n.home-container .home-header-button {\n    height: 40px;\n    color: #151515;\n    font-size: 20px;\n    background: #f7941d;\n    border: none;\n}\n.home-container .quotes-section {\n    margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  width: 80%;\n  align-items: center;\n}\n.home-container .quotes-section-title {\n    font-size: 28px;\n}\n.home-container .quotes-container {\n    flex-direction: column;\n    gap: 30px;\n    height: auto;\n    width: 100%\n}\n\n.home-container .quotes-left-content {\n    max-width:fit-content;\n    text-align: left;\n}\n\n.home-container .quotes-left-content .subtitle {\n    font-size: 24px;\n}\n.home-container .work-section {\n    flex-direction: column;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n    height: auto;\n    width: 100%\n  }\n.home-container .work-header {\n    font-size: 28px;\n  }\n  \n  .home-container .work-body {\n   flex-direction: column;\n   height: auto;\n   width: 80%;\n  }\n  \n  .home-container  .work-banner {\n    /* Add any styles for the Banner1 component if needed */\n  }\n  \n  .home-container  .work-content {\n    max-width:fit-content;\n    text-align: left;\n  }\n  \n  .home-container  .work-title {\n    font-size: 24px;\n  }\n  \n  .home-container .highlight-text {\n    color: #f7941d;\n  }\n  \n  .home-container  .work-description {\n    font-size: 16px;\n    margin-top: 10px;\n  }\n  \n  .home-container  .work-button {\n    margin-top: 20px;\n  }\n  \n  .home-container .why-thy-button {\n    height: 30px;\n    color: #151515;\n    font-size: 22px;\n    background: #f7941d;\n    border: none;\n    font-weight: 600;\n    margin-top: 20px;\n  }\n\n  .home-container .image-section-title {\n    font-size: 28px;\n}\n.home-container .image-section-div {\n    flex-direction: column;\n    width: 80%;\n}\n\n.home-container .image-section .highlight {\n    color: #f7941d;\n}\n.home-container .contact-title{\n    font-size: 40px;\n}\n.home-container .carousel-section-title {\n    font-size: 40px;\n}\n}\n.ant-spin .ant-spin-dot-holder{\n    color: #f7941d;\n}\n/* === Carousel Dots Customization === */\n.ant-carousel .slick-dots {\n  bottom: 0; /* Adjust vertical positioning if needed */\n}\n\n.ant-carousel .slick-dots li {\n  margin: 0 6px;\n}\n\n.ant-carousel .slick-dots li button {\n  background-color: #888888; /* Inactive dot color */\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  opacity: 1; /* Ensures visible */\n  transition: background-color 0.3s ease;\n}\n\n.ant-carousel .slick-dots li.slick-active button {\n  background-color: #f7941d !important; /* Active dot color */\n}\n.home-container .contact-form:hover{\n    transform: scale(1.01);\n    box-shadow: 0 0 15px #d9d9d91f;\n}\n.home-container .contact-form{\n    box-shadow: 0 0 15px #bebdbd1f;\n    margin-top: 25px;\n}\n\n.home-container .image-section .image-item {\n    box-shadow: 0 0 15px #bebdbd1f;\n}\n\n.home-container .image-section .image-item:hover {\n    transform: scale(1.01);\n    box-shadow: 0 0 15px #d9d9d91f;\n}\n.underline-path {\n  stroke-dasharray: 300;\n  stroke-dashoffset: 300;\n  animation: drawLine 2s linear infinite;\n}\n\n@keyframes drawLine {\n  0% {\n    stroke-dashoffset: 300;\n  }\n  50% {\n    stroke-dashoffset: 0;\n  }\n  100% {\n    stroke-dashoffset: -300;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
